// Skin Lab: one gpt-image-2 drawing per call with our OpenAI key
// (api/cloudflare/src/routes/admin/skin-lab.ts). Super admin only.
import api from './client';
import type { ImageUsage } from '@/lib/skin-lab';

export interface SkinLabDraw {
  /** PNG, base64. */
  image: string;
  usage: ImageUsage | null;
  /** Time the OpenAI call took. */
  ms: number;
}

export function drawSkinImage(input: {
  prompt: string; size: string; quality: string; label: string; images: Blob[];
}): Promise<SkinLabDraw> {
  const form = new FormData();
  form.append('prompt', input.prompt);
  form.append('size', input.size);
  form.append('quality', input.quality);
  form.append('label', input.label);
  input.images.forEach((img, i) => form.append('image', img, `ref${i + 1}.png`));
  return api.form<SkinLabDraw>('/admin/skin-lab/draw', form);
}
